import { create } from '@bufbuild/protobuf';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { PackageProviderName } from 'data/ppoints/constants';
import { goBackendApi } from 'hooks/api/httpApi';
import { EnabledShippingTypesRequestSchema } from '../../../../../../../../../pb/requests/v1/enabled_shipping_types_request_pb';
import { EnabledShippingTypesUpdateProviderRequestSchema } from '../../../../../../../../../pb/requests/v1/enabled_shipping_types_update_provider_request_pb';
import { EnabledShippingTypesResponseSchema } from '../../../../../../../../../pb/responses/v1/enabled_shipping_types_response_pb';
import { EnabledShippingType, EnabledShippingTypeByProvider } from '../models/enabled-shipping.types';

export const saveAcivatedShippingTypes = async (data: EnabledShippingType[]) => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .putRequest(
            EnabledShippingTypesRequestSchema,
            EnabledShippingTypesResponseSchema,
            '/api/v1/enabled-shipping-types',
            create(EnabledShippingTypesRequestSchema, {
                data: data,
            })
        )
        .then((res) => res);
};

export const saveAcivatedShippingTypesByProvider = async (
    data: EnabledShippingTypeByProvider,
    packageProvider: PackageProviderName
) => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .putRequest(
            EnabledShippingTypesUpdateProviderRequestSchema,
            null,
            `/api/v1/enabled-shipping-types/${packageProvider}`,
            create(EnabledShippingTypesUpdateProviderRequestSchema, data)
        )
        .then((res) => res);
};

export const activateAllShippingTypes = async (packageProvider: PackageProviderName) => {
    return goBackendApi().post(`/api/v1/enabled-shipping-types/${packageProvider}/all`);
};
